import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn.js";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type ?? "text"}
      className={cn(
        "h-9 w-full rounded-sm border border-rule bg-surface-2 px-3 text-body text-ink placeholder:text-ink-mute",
        "focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-0",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
